module.exports = __webpack_public_path__ + "static/media/MasterCard.de7e80c1.png";